/**
 * DetailMask component
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Detail mask (dark fade).
 */
const DetailMask = styled.div`
  background: linear-gradient(
    540deg,
    rgba(0, 0, 0, 0) 34.6%,
    #000 75.18%,
    #010101 78.94%,
    #010101 91.31%
  );
  bottom: 0;
  height: ${1080 * Screen.widthRatio}px;
  left: ${85 * Screen.widthRatio}px;
  position: absolute;
  width: ${1857 * Screen.widthRatio}px;
  z-index: 1;
`;

export default withOpacity(DetailMask);
